import { render, staticRenderFns } from "./CityConfig.vue?vue&type=template&id=5e672caa&scoped=true"
import script from "./CityConfig.vue?vue&type=script&lang=js"
export * from "./CityConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e672caa",
  null
  
)

export default component.exports